import type { MapOptions } from 'mapbox-gl';
import { BD_GEOGRAPHIC_GERMANY_BBOX } from '../geographic-values';

export const BD_DEFAULT_MAP_OPTIONS: MapOptions = {
  container: 'map-container',
  style: 'mapbox://styles/mapbox/streets-v12',
  bounds: BD_GEOGRAPHIC_GERMANY_BBOX,
  preserveDrawingBuffer: true,
  cooperativeGestures: true,
  locale: {
    'ScrollZoomBlocker.CtrlMessage':
      'Nutzen Sie ctrl + scroll, um in der Karte zu zoomen',
    'ScrollZoomBlocker.CmdMessage':
      'Nutzen Sie ⌘ + scroll, um in der Karte zu zoomen',
    'TouchPanBlocker.Message': 'Nutzen Sie 2 Finger, um in der Karte zu zoomen',
  },
};
export const AYS_MAP_OPTIONS: MapOptions = {
  ...BD_DEFAULT_MAP_OPTIONS,
  center: [8.689091, 50.108202],
  zoom: 8,
};

export const AYS_STATIC_MAP_OPTIONS: MapOptions = {
  ...BD_DEFAULT_MAP_OPTIONS,
  center: [8.689091, 50.108202],
  zoom: 9,
  interactive: false,
};
